module.exports = __webpack_public_path__ + "img/lotteryType.3636171b.png";